import { render, staticRenderFns } from "./Good.vue?vue&type=template&id=32bf2d1c&lang=pug&"
import script from "./Good.vue?vue&type=script&lang=ts&"
export * from "./Good.vue?vue&type=script&lang=ts&"
import style0 from "./Good.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports